// @ts-nocheck
import React from "react";
import { useParams, useNavigate } from "@tanstack/react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";
import { trpcClient } from "@/lib/trpc";
import { QCFinalForm } from "./QCFinalForm";

export default function QCFinalEdit() {
  const { checkId } = useParams({ strict: false }) as { checkId: string };
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: item, isLoading } = useQuery({
    queryKey: ["qcFinal", checkId],
    queryFn: async () =>
      (trpcClient as any).qcFinal.getById.query({ id: checkId }),
    enabled: !!checkId,
  });

  const handleSubmit = async (data: any) => {
    try {
      const payload = {
        ...data,
        aqlStandard: Number(data.aqlStandard) || 1.5,
      };
      await (trpcClient as any).qcFinal.update.mutate({
        id: checkId,
        data: payload,
      });
      toast.success("Cập nhật phiếu nghiệm thu thành phẩm (FQC) thành công!");
      await queryClient.invalidateQueries({ queryKey: ["qcFinal"] });
      await queryClient.invalidateQueries({ queryKey: ["qc-final-all"] });
      navigate({
        to: "/qc-final/$checkId",
        params: { checkId },
        replace: true,
      });
    } catch (err: any) {
      toast.error(err?.message || "Lỗi khi cập nhật phiếu FQC");
      throw err;
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Kiểm tra Thành phẩm (FQC)", to: "/qc-final" },
        { label: item?.finalQcId || checkId, to: `/qc-final/${checkId}` },
        { label: "Chỉnh sửa" },
      ]}
      title={`Sửa ${item?.finalQcId || ""}`}
      onBack={() =>
        navigate({ to: "/qc-final/$checkId", params: { checkId } })
      }
      actions={
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() =>
              navigate({ to: "/qc-final/$checkId", params: { checkId } })
            }
          >
            Hủy
          </Button>
          <Button
            type="submit"
            size="sm"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold"
            onClick={() => {
              const formEl = document.getElementById(
                "qc-final-canonical-form"
              ) as HTMLFormElement | null;
              formEl?.requestSubmit();
            }}
          >
            <Save className="w-4 h-4 mr-1.5" /> Cập Nhật Biên Bản FQC
          </Button>
        </div>
      }
    >
      <QCFinalForm
        containerMode="embedded"
        initialData={item}
        onSubmit={handleSubmit}
        onCancel={() =>
          navigate({ to: "/qc-final/$checkId", params: { checkId } })
        }
      />
    </StandardDetailLayout>
  );
}
